import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useFormContext } from 'react-hook-form-mui';

interface IProps {
    totalValuePropertyName: string
    currentValuePropertyName: string
}

export default function RenderPercentageValueBetweenTwoValues(props: IProps) {
    var { watch } = useFormContext();
    var totalValue: number = watch(props.totalValuePropertyName);
    var currentValue: number = watch(props.currentValuePropertyName);

    return (
        <Box>
            {(totalValue !== null && totalValue != 0 && currentValue !== null && currentValue != 0) &&
                <Typography>
                    {((currentValue / totalValue) * 100).toFixed(1)}%
                </Typography>
            }
        </Box>
    );
}